<template>
  <div>
    <section class="home__start">
      <div class="home__start-wrapper">
        <h1>
          Unique furniture in vintage style
        </h1>
        <span>By Eva & Thomas Buchwald</span>
        <fa-icon :icon="['fas', 'mouse']" size="xs" />
      </div>
    </section>
    <UiDevider />
    <section class="home__info">
      <div class="section-head">
        <h2>About us</h2>
        <p>
          Our merchandise are unique in many ways, we have old restored accent
          chairs, Canape's, Sofas and unique Seats etc. We restore our
          furnitures in an earth friendly way. We are using natural oils to
          restore the wood condition. We choose fabrics that are very unique
          from its designs and when most possible produced and made in Europe.
          Our accent chairs are always "one and only" for special customers like
          you! We also offer wide range of unique pieces for decorations, pieces
          that not everyone has. We offer services such as:
        </p>
        <ul>
          <li>Interior designs</li>
          <li>Furniture repair</li>
          <li>Old furniture restorations</li>
          <li>Upholstery</li>
        </ul>
      </div>
    </section>
    <UiDevider />
    <section class="home__categories">
      <div class="section-head">
        <h2>Categories</h2>
        <p>Browse through our categories!</p>
      </div>
      <div class="home__categories-items">
        <template v-for="(category, index) in categories">
          <UiCategorie
            class="home__categories-categorie"
            :key="index"
            :index="index"
            :category="category"
          />
        </template>
      </div>
    </section>
    <UiDevider />
    <section class="home__products">
      <div class="section-head">
        <h2>Products</h2>
        <p>Check some of our custom-made Products!</p>
      </div>
      <div class="home__products-items">
        <template v-for="product in products">
          <UiProduct
            class="home__products-product"
            :key="product.id"
            :product="product"
          />
        </template>
      </div>
    </section>
  </div>
</template>
<script>
import { allCategories } from '@/services/api/category.js'
import { randomProducts } from '@/services/api/product.js'

export default {
  data() {
    return {
      categories: [],
      products: []
    }
  },
  mounted() {
    return Promise.all([allCategories(), randomProducts()]).then(response => {
      ;(this.categories = response[0].categories),
        (this.products = response[1].products)
    })
  }
}
</script>

<style lang="sass">
.home__start
  @apply flex justify-center items-center w-full min-h-screen pb-16
  &-wrapper
    @apply flex flex-col items-center
    h1
      font-size: 5rem
      background-image: url(../assets/images/parralax_bg.jpeg)
      -webkit-background-clip: text
      background-attachment: fixed
      @apply italic bg-cover bg-clip-text text-transparent font-semibold
    span
      @apply text-2xl
    svg
      animation: MoveUpDown 1.3s ease-in-out infinite
      @apply absolute bottom-0 mb-2 text-5xl

.home__info
  @apply flex flex-col justify-center items-center

.home__categories
  @apply
  &-items
    @apply px-4 w-full py-2 mt-4 flex-wrap
  &-categorie
    max-height: 250px
    @apply w-full flex border-white mb-4 relative

.home__products
  &-items
    @apply px-4 mt-2 flex flex-col

@screen sm
  .home__start
    &-wrapper
      h1
        font-size: 6rem
        @apply px-6
  .home__info
    &-wrapper
      @apply w-3/4
  .home__categories
    &-items
      @apply flex-grow flex flex-row relative
    &-categorie
      max-height: fit-content
      @apply w-2/6 relative flex justify-center px-2
  .home__products
    &-items
      @apply flex-row flex-wrap
    &-product
      @apply w-1/3 mb-0 px-2

@screen xl
  .home__start
    &-wrapper
      h1
        font-size: 8rem
        @apply px-6

@keyframes MoveUpDown
  0%, 100%
    bottom: 0
  50%
    bottom: 20px
</style>
